import LoadingIndicator from 'modules/common/LoadingIndicator';
import Tabs from 'modules/common/Tabs';
import PropTypes from 'prop-types';
import React, {lazy, Suspense} from 'react';
import {FormattedMessage} from 'react-intl';
import ProjectFeedback from './ProjectFeedback';
import ProjectHistory from './ProjectHistory';
import {circle} from './styles.scss';

const CodeReview = lazy(() => import('./CodeReview'));

const ProjectReview = ({
  feedback,
  files,
  allProjectSubmission,
  step,
  deadlineHasPassed,
  daysLeftUntilDeadline,
  hasSubscription,
  trackId,
  partner,
  userId,
}) => {
  const reviewCountArray =
    files &&
    files.length > 0 &&
    files.map(
      (file) => file.reviewSet.edges.length > 0 && file.reviewSet.edges.length,
    );
  const reviewCount =
    reviewCountArray && reviewCountArray.reduce((acc, review) => acc + review);

  return (
    <div className="tc pv5">
      <Tabs
        titles={[
          <FormattedMessage id="project_review" />,
          <>
            {reviewCount > 0 && (
              <span className={`${circle} ph2 mh2`}>{reviewCount}</span>
            )}
            <FormattedMessage id="review" />
          </>,
          <FormattedMessage id="history" />,
        ]}
        contents={[
          <ProjectFeedback
            hasSubscription={hasSubscription}
            feedback={feedback}
            step={step}
            deadlineHasPassed={deadlineHasPassed}
            daysLeftUntilDeadline={daysLeftUntilDeadline}
            trackId={trackId}
            partner={partner}
            userId={userId}
          />,
          <Suspense fallback={<LoadingIndicator />}>
            <CodeReview files={files} />
          </Suspense>,
          <ProjectHistory
            feedback={feedback}
            files={files}
            allProjectSubmission={allProjectSubmission}
            step={step}
            trackId={trackId}
            partner={partner}
          />,
        ]}
        isProjectReview
      />
    </div>
  );
};

ProjectReview.propTypes = {
  feedback: PropTypes.array.isRequired,
  files: PropTypes.array.isRequired,
  allProjectSubmission: PropTypes.array.isRequired,
  step: PropTypes.object.isRequired,
  deadlineHasPassed: PropTypes.bool,
  daysLeftUntilDeadline: PropTypes.number.isRequired,
  hasSubscription: PropTypes.bool.isRequired,
  trackId: PropTypes.string.isRequired,
  partner: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default ProjectReview;
